<template>
  <div id="body">
    <b-row>
      <b-col sm="10">
        <b-input-group prepend="url" >
          <b-form-input v-model="url"/>
        </b-input-group>
      </b-col>
      <b-col sm="2">
        <b-button variant="primary" @click="getPrice">
          검색
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-input-group prepend="name" >
          <b-form-select 
            v-model="id" 
            :options="item_list"
            value-field="_id"
            text-field="name"
          >
          </b-form-select>
        </b-input-group>
        <div v-if="item">
          <p>ID: {{item._id}}</p>
          <p>영양성분: {{item.nutritions}}</p>
          <p>가격 갯수: {{item.prices.length}}</p>
          <p>평균 가격: {{meanPrice}}</p>
          <p>최저 가격: {{lowestPrice}}</p>
        </div>
      </b-col>
      <b-col sm='6'>
        <div v-if="price_info">
          <p>{{alreadyHave > -1?'이미 존재하는 링크': '새로운 링크'}}{{alreadyHave}}</p>
          <p>이름: <b-form-input v-model="name" /></p>
          <p>사이트: <b-button size="sm" v-b-modal.modal-1>{{price_info.mall}}</b-button></p>
          <p>총가격: {{Number(price_info.price) + Number(price_info.ship)}}</p>
          <p>가격: <b-form-input v-model="price_info.price" type='number' /></p>
          <p>배송비: <b-form-input v-model="price_info.ship" type='number' /></p>
          <p>수량: <b-form-input v-model="price_info.amount" type='number' /></p>
        </div>
        <b-button variant="primary" @click="addPrice">
          추가
        </b-button>

      </b-col>
    </b-row>
    <b-modal id="modal-1" size="xl">
      <iframe :src="url"/>
    </b-modal>
  </div>
</template>

<script>
import util from '../util'
import {
    BRow, BCol, BCard, BModal,
    BForm, BFormGroup, BFormInput, BInputGroup, BFormSelect, BButton,
    BIconArrowClockwise
} from 'bootstrap-vue'

export default {
  name: 'InputComponent',
  components: {
    BRow, BCol, BCard, BModal,
    BForm, BFormGroup, BFormInput, BInputGroup, BFormSelect, BButton,
    BIconArrowClockwise
  },
  data () {
    return {
      id: null,
      item: null,
      name: null,
      url: '',
      item_list: [],
      price_info: null,
      alreadyHave: false
    }
  },
  computed: {
  },
  watch: {
    id (v) {
      if (v) {
        this.getItem(v)
      }
    },
    name (v) {
      if (v) {
        this.searchItem()
      }
    }
  },
  methods: {
    getItem(v) {
      util.get(`item/${v}`).then( res =>{
        this.item = res.data
        let prices = this.item.prices
        this.meanPrice = prices.reduce((a,b) => a + b.unit_total, 0) / prices.length
        this.lowestPrice = prices.reduce((a,b) => Math.min(a, b.unit_total), 1000000000)
        this.price_info.amount = Math.round((this.price_info.price + this.price_info.ship) / this.meanPrice)
        this.alreadyHave = prices.findIndex(p => p.link == this.url)
      })
    },
    searchItem () {
      util.get(`item/search/${encodeURIComponent(this.name)}`).then(res => {
        this.item_list = res.data
        if (this.item_list.length > 0)  this.id = this.item_list[0]._id
      }).catch(err => {
        console.log(err)
      })
    },
    getPrice () {
      if (this.url != '') {
        util.get_to_crawl('price_info', {
          link: this.url
        }).then(res => {
          this.price_info = res.data
          this.name = this.price_info.name
        })
      }
    },
    addPrice() {
      util.post_to_crawl('add_price', {
        id: this.id,
        info: this.price_info,
        link: this.url,
        have: this.alreadyHave
      }).then(res => {
        this.item = null
        this.getItem(this.id)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#body {
  padding: 20px;
}

div.row {
  margin: 20px 0;
}
div.row.result {
  height: 100vh;
}
.modal-dialog {
  max-width: 100% !important;
}
iframe {
  width: 120%;
  height: 50vh;
  -ms-zoom: 0.75;
  -moz-transform: scale(0.75);
  -moz-transform-origin: 0 0;
  -o-transform: scale(0.75);
  -o-transform-origin: 0 0;
  -webkit-transform: scale(0.75);
  -webkit-transform-origin: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Input.vue